// Razorpay Checkout JS loader + helper

const SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";

let loadingPromise = null;

export function loadRazorpayScript() {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (window.Razorpay) return Promise.resolve(true);
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(true));
      existing.addEventListener("error", () => resolve(false));
      return;
    }
    const script = document.createElement("script");
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => {
      loadingPromise = null;
      resolve(false);
    };
    document.head.appendChild(script);
  });
  return loadingPromise;
}

/**
 * Opens the Razorpay Checkout modal.
 * @param {object} order — server response from /api/checkout/order
 * @param {object} options — { onSuccess(paymentResponse), onDismiss(), email?, contact? }
 */
export async function openRazorpay(order, { onSuccess, onDismiss, email, contact } = {}) {
  const ok = await loadRazorpayScript();
  if (!ok) {
    throw new Error("Could not load Razorpay checkout. Please retry.");
  }

  const opts = {
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    name: order.name || "Pookielawyer.com",
    description: order.description || "Pookie Pro — Monthly",
    order_id: order.order_id,
    prefill: {
      email: email || order?.prefill?.email || "",
      contact: contact || order?.prefill?.contact || "",
    },
    notes: order.notes || {},
    theme: { color: "#FF3B30" },
    modal: {
      ondismiss: () => {
        onDismiss && onDismiss();
      },
      escape: true,
    },
    handler: (response) => {
      onSuccess && onSuccess(response);
    },
  };

  const rzp = new window.Razorpay(opts);
  rzp.on("payment.failed", (resp) => {
    onDismiss && onDismiss(resp?.error);
  });
  rzp.open();
  return rzp;
}
